/**
 * 仪器类型配置，用于过滤仪器和站点
 */
export default class DeviceCategoryConfig {
  categoryId
  required
  filter

  /**
   * 构造函数
   * @param categoryId<Number>  仪器类型ID
   * @param required<Boolean>   是否具备
   * @param filter<Function>    过滤因子的函数
   */
  constructor (categoryId, required = false, filter) {
    this.categoryId = categoryId
    this.required = required
    this.filter = filter
  }
}



// WEBPACK FOOTER //
// ./src/model/DeviceCategoryConfig.js